<div class="sec-page">
  <div class="security">
    <p class="sec-guideline">Account Security Questions</p>
  </div>
  <div class="questions">
    <div class="header">
      <p class="info">Select New Account Security Questions</p>
      <p class="details mb-0">
        Select 3 security questions below. These questions will help us verify
        your identity in the event you forget your password.
      </p>
      <div class="req"><span class="req1">*</span> Required field</div>
    </div>

    <form #securityQuestionsForm="ngForm" (ngSubmit)="submit()">
      <div class="d-flex custom-flex-box">
        <div class="col-sm-6 col-lg-6 pl-0 col-padding">
          <div class="password--div form-item password-field custom-width-password"> <label class="text-label">Current
              Password <span class="req1">*</span></label> 
              <div class="input-wrapper">
                <input class="form-control tag ans " [ngClass]="{
                  'border-invalid': !password0.valid && password0.touched
                }" [type]="currentPasswordShowPasswordIcon ? 'text' : 'password'" class="form-control" id="password0" name="password0" [(ngModel)]="currentpassword"
                required minlength="8" maxlength="14" #password0="ngModel"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$" />
                <i *ngIf="currentPasswordShowPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="toggleCurrentPassword()"></i>
                <i *ngIf="!currentPasswordShowPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="toggleCurrentPassword()"></i>
              </div>
            <div *ngIf="!password0.valid && password0.touched && !currentpassword"
              class="error-message pass-margin"> Password Required
            </div>
            <div *ngIf="!password0.valid && password0.touched && currentpassword" class="error-message"> Invalid Password
            </div>
          </div>
          <hr class="password-splitter" />
        </div>
        <div class="d-flex w-100">
          <div class="d-flex-column col-md-12 secbox-size mobile-padding"> <label for="thirdq" class="infoq">Select a
              Question</label><span class="req1"> *</span><br /> <ng-select class="col-md-12 tag ans classic custom-dropdown form-control"
              id="thirdQuestion" name="thirdQuestion" [(ngModel)]="selectedQuestions.thirdQuestionId"
              (change)="change('thirdQuestionId', $event)" required>
              <ng-option value="" selected disabled hidden>Select</ng-option>
              <ng-option *ngFor="let question of uniqueSecurityQuestion(2)" value="{{question.Id}}"> {{ question.QuestionText }}
              </ng-option>
            </ng-select>
            <div class="answer"> <label for="thirda" class="infoq">Your Answer</label><span class="req1"> *</span><br />
              <input type="text" name="thirda" class="col-md-12 tag ans" name="thirdAnswer" [(ngModel)]="thirdAnswer"
                (blur)="checkFields('thirdAnswer')" [ngClass]="{
                      'error-border': thirdField
                    }" required />
              <div *ngIf="thirdField" class="error-message"> This is a mandatory field
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex secbox-size help-question mt-0">
        <div class="d-flex-column col-md-6 mobile-padding"> <label for="firstq" class="infoq">Select a Question</label><span
            class="req1"> *</span><br /> <ng-select class="col-md-12 tag ans classic custom-dropdown form-control" id="firstQuestion"
            name="firstQuestion" [(ngModel)]="selectedQuestions.firstQuestionId" (change)="change('firstQuestionId', $event)"
            required>
            <ng-option value="" selected disabled hidden>Select</ng-option>
            <ng-option *ngFor="let question of uniqueSecurityQuestion(0)" value="{{question.Id}}" > {{ question.QuestionText }}
            </ng-option>
          </ng-select> </div>
        <div class="d-flex-column col-md-6 display"> <label for="secondq" class="infoq">Select a Question</label><span
            class="req1"> *</span><br /> <ng-select class="col-md-12 tag ans classic custom-dropdown form-control"
            (change)="change('secondQuestionId', $event)" id="secondQuestion" name="secondQuestion"
            [(ngModel)]="selectedQuestions.secondQuestionId" required>
            <ng-option value="" selected disabled hidden>Select</ng-option>
            <ng-option *ngFor="let question of uniqueSecurityQuestion(1)" value="{{question.Id}}"> {{ question.QuestionText }}
            </ng-option>
          </ng-select> </div>
      </div>
      <div class="d-flex secbox-size">
        <div class="d-flex-column col-md-6 answer mobile-padding"> <label for="firsta" class="infoq">Your
            Answer</label><span class="req1"> *</span><br /> <input type="text" id="firsta" class="col-md-12 tag ans"
            name="firstAnswer" [(ngModel)]="firstAnswer" (blur)="checkFields('firstAnswer')" [ngClass]="{
                  'error-border': firstField
                }" required />
          <div *ngIf="firstField" class="error-message find"> This is a mandatory field
          </div>
          <hr class="display1">
        </div>
        <div class="d-flex-column col-md-6 answer display"> <label for="seconda" class="infoq">Your Answer</label><span
            class="req1"> *</span><br /> <input type="text" id="seconda" class="col-md-12 tag ans" name="secondAnswer"
            [(ngModel)]="secondAnswer" (blur)="checkFields('secondAnswer')" [ngClass]="{
                  'error-border': secondField
                }" required />
          <div *ngIf="secondField" class="error-message"> This is a mandatory field
          </div>
        </div>
      </div> <!-- mobile responsive div -->
      <div class="d-flex-column col-md-6 secbox-size last display1 mobile-padding"> <label for="thirdq" class="infoq">Select a Question</label><span class="req1"> *</span><br /> 
        <ng-select class="col-md-12 tag ans classic custom-dropdown form-control" id="secondQuestion"
          name="secondQuestion" [(ngModel)]="selectedQuestions.secondQuestionId" (change)="change('secondQuestionId', $event)"
          required>
          <ng-option value="" selected disabled hidden>Select</ng-option>
          <ng-option *ngFor="let question of uniqueSecurityQuestion(1)" value="{{question.Id}}"> {{ question.QuestionText }}
          </ng-option>
        </ng-select>
        <div class="answer"> <label for="seconda" class="infoq">Your Answer</label><span class="req1"> *</span><br /> <input
            type="text" name="seconda" class="col-md-12 tag ans" name="secondAnswer" [(ngModel)]="secondAnswer"
            (blur)="checkFields('secondAnswer')" [ngClass]="{
                  'error-border': secondField
                }" required />
          <div *ngIf="secondField" class="error-message"> This is a mandatory field
          </div>
        </div>
        <hr class="display1 btn-mobile-responsive">
      </div>
      <div class="d-flex justify-content-end media-button btn-mobile-responsive"> <button class="continue" type="submit"
          [ngClass]="{banner: !thirdField}" [disabled]="!securityQuestionsForm.valid"> Continue
        </button> </div>
    </form>
  </div>
  <div class="d-flex justify-content-end media-button btn-dislay"> <button class="continue" type="submit"
    [ngClass]="{banner: !thirdField}" [disabled]="!securityQuestionsForm.valid"> Continue
  </button> </div>
</div>